import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/adminapi/tuan/goodsOptions',
  goodsSkuDetail: '/adminapi/tuan/goodsSkuDetail',
  tuanDetail: '/adminapi/tuan/tuanDetail',
  tuanList: '/adminapi/tuan/tuanList',
  tuanEdit: '/adminapi/tuan/tuanEdit',
  tuanAdd: '/adminapi/tuan/tuanAdd',
  tuanRankEdit: '/adminapi/tuan/tuanRankEdit',
  tuanDelete: '/adminapi/tuan/tuanDelete',
  setTuanAllStatus: '/adminapi/tuan/setTuanAllStatus',
  tuanOrderList: '/badminapi/tuan/orderList',
}

export default api

export function getTuanList(parameter) {
  return axios({
    url: api.tuanList,
    method: 'get',
    params: parameter
  })
}
export function getTuanDetail(parameter) {
  return axios({
    url: api.tuanDetail,
    method: 'get',
    params: parameter
  })
}
export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function getGoodsSkuDetail(parameter) {
  return axios({
    url: api.goodsSkuDetail,
    method: 'get',
    params: parameter
  })
}
export function editTuan(parameter) {
  return axios({
    url: api.tuanEdit,
    method: 'post',
    data: parameter
  })
}
export function addTuan(parameter) {
  return axios({
    url: api.tuanAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteTuan(parameter) {
  return axios({
    url: api.tuanDelete,
    method: 'post',
    data: parameter
  })
}

export function setTuanRank(parameter) {
  return axios({
    url: api.tuanRankEdit,
    method: 'post',
    data: parameter
  })
}


export function setTuanAllStatus(parameter) {
  return axios({
    url: api.setTuanAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getTuanUserList(parameter) {
  return axios({
    url: api.tuanOrderList,
    method: 'post',
    data: parameter
  })
}